/* @ngInject */
export default function PartCountFormatterService($translate, $q, NumberFormatterService) {
    function formatAvailability(uniquePart) {
        const formattedNumber = formatLargeNumber(uniquePart.totalParts);

        $translate('label__inventory', {numberOf: formattedNumber}).then(function (inventory) {
            if (formattedNumber !== 0) {
                uniquePart.partCountDisplay = inventory.valueOf();
            } else {
                // In the case that it's 0, we want to just perform a replace with the zero, instead of
                // re-running the translate function we're in.
                uniquePart.partCountDisplay = inventory.valueOf().replace(
                    /0/g,
                    $translate.instant('label__negation').valueOf()
                );
            }
        })['catch'](function (error) {
            console.error(error);
        });

        return uniquePart.partCountDisplay;
    }

    function formatAllRegionAvailability(uniquePart) {
        const formattedNumber = formatLargeNumber(uniquePart.allRegionTotalParts);
        let label = 'label__total__inventory';
        if (formattedNumber === 0) {
            label = 'label__inventory';
        }

        $translate(label, {numberOf: formattedNumber}).then(function (inventory) {
            if (formattedNumber !== 0) {
                uniquePart.allRegionPartCountDisplay = inventory.valueOf();
            } else {
                // In the case that it's 0, we want to just perform a replace with the zero, instead of
                // re-running the translate function we're in.
                uniquePart.allRegionPartCountDisplay = inventory.valueOf().replace(
                    /0/g,
                    $translate.instant('label__negation').valueOf()
                );
            }
        })['catch'](function (error) {
            console.error(error);
        });

        return uniquePart.allRegionPartCountDisplay;
    }

    function formatLargeNumber(number) {
        if (number !== undefined) {
            if (number !== 0) {
                if (parseInt(number) > 1000) {
                    return NumberFormatterService.shortFormatter(parseInt(number), 1) + '+';
                } else {
                    return parseInt(number);
                }
            } else {
                return number;
            }
        } else {
            return '---';
        }
    }

    function formatPartCount(definition) {
        var formattedNumber = formatLargeNumber(definition.partCount);
        // fixes infinite digest with promises: https://stackoverflow.com/a/45563659/4233452
        $translate('label__negation', 'en').then(function (negation) {
            definition.partCountDisplay = (formattedNumber === 0) ? negation + ' ' : formattedNumber;
        })['catch'](function (error) {
            console.error(error);
        });

        return definition;
    }

    function getLabelByDefinition(definition) {
        const isKit = definition.nameBreadcrumbs.filter( item => item.display.startsWith('Engineering Kits')).length > 0;
        if (isKit && definition.partCount < 2) {
            return 'label__kit';
        } else if (isKit) {
            return 'label__kits';
        } else if (!isKit && definition.partCount < 2) {
            return 'label__part';
        } else {
            return 'label__parts';
        }
    }

    return {
        formatPartCount: formatPartCount,
        formatLargeNumber: formatLargeNumber,
        formatAvailability: formatAvailability,
        formatAllRegionAvailability: formatAllRegionAvailability,
        getLabelByDefinition: getLabelByDefinition,
    };
}
